export const MAIL_REVIEW_QUERY_KEY = ['mail-review']
export const MAIL_REVIEW_MUTATION_KEY = ['mail-review', 'decision']

export function hasOwnerRole(user) {
  return (
    Array.isArray(user?.roles) &&
    user.roles.some((role) => role?.name === 'owner')
  )
}

export function hasSuperadminRole(user) {
  return (
    Array.isArray(user?.roles) &&
    user.roles.some((role) => role?.name === 'superadmin')
  )
}

export function isOwnerOnly(user) {
  return hasOwnerRole(user) && !hasSuperadminRole(user)
}

export function hasMailReviewRole(user) {
  return (
    Array.isArray(user?.roles) &&
    user.roles.some(
      (role) => role?.name === 'owner' || role?.name === 'superadmin',
    )
  )
}

export function isMailReviewDeploymentEnabled(
  value = import.meta.env.VITE_MAIL_REVIEW_UI_ENABLED,
) {
  return value === 'true'
}

export function canAccessMailReview({
  user,
  freshAuthVerified,
  deploymentEnabled = isMailReviewDeploymentEnabled(),
}) {
  return (
    deploymentEnabled === true &&
    freshAuthVerified === true &&
    user?.features?.mail_review_enabled === true &&
    hasMailReviewRole(user)
  )
}

export function purgeMailReviewCache(queryClient) {
  void queryClient.cancelQueries({ queryKey: MAIL_REVIEW_QUERY_KEY })
  queryClient.removeQueries({ queryKey: MAIL_REVIEW_QUERY_KEY })

  purgeMailReviewMutations(queryClient)
}

export function purgeMailReviewMutations(queryClient) {
  const mutationCache = queryClient.getMutationCache()
  mutationCache.getAll().forEach((mutation) => {
    if (mutation.options.mutationKey?.[0] === MAIL_REVIEW_MUTATION_KEY[0]) {
      mutationCache.remove(mutation)
    }
  })
}
